import { render, staticRenderFns } from "./super-card.vue?vue&type=template&id=5aeb1665&scoped=true&lang=pug&"
import script from "./super-card.vue?vue&type=script&lang=js&"
export * from "./super-card.vue?vue&type=script&lang=js&"
import style0 from "./super-card.vue?vue&type=style&index=0&id=5aeb1665&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb1665",
  null
  
)

export default component.exports